export const AssetTransferDirection = {
   input   : 'in',
   output  : 'out'
 };
 
